<template>
  <div class="flex w-full items-center justify-between p-4">
    <div class="flex items-center gap-2">
      <i class="icon-[lucide--triangle-alert] text-warning-background" />
      <p class="m-0 text-sm">
        {{ $t('importFailed.title') }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
